import { notifications } from '@mantine/notifications';
import { initCommerceApiWithGlobals } from 'common-api';
import { globals, isBrowser, logger } from 'common-ui';
import { getRecoil } from 'recoil-nexus';
import { authAtom } from '../../atoms/authAtom';

const commerceApiExtraConfig = (publicCsrfValue = '') => ({
  webApiExtraHeaders: {
    [globals.authAndWebApiCsrfHeaderName as string]: publicCsrfValue,
  },
});

export const refreshAuthToken = async (): Promise<true | undefined> => {
  if (!isBrowser()) {
    logger.log('refreshAuthToken skipping as not in browser');
    return;
  }

  try {
    const authAtomState = getRecoil(authAtom);
    const commerceApi = initCommerceApiWithGlobals(commerceApiExtraConfig(authAtomState.publicCsrf));
    // call refresh endpoint
    await commerceApi.Auth.refresh();
    return true;
  } catch (error: any) {
    logger.log('API ERROR', error);
    notifications.show({
      message: 'Your session has expired. Please log in again.',
      autoClose: 3000,
      top: 15,
      color: 'red',
    });
    // If the error is a 401, redirect the user to the login page
    if (error.response && error.response.status === 401 && location.pathname !== '/jsp/curity/signin.jsp') {
      logger.error('User session has timed out. Redirecting user to login page.');
      window.location.href = `/jsp/curity/signin.jsp?redirectionURL=${window.location.href}`;
    } else {
      throw error;
    }
  }
};
